/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Letter Templates API
 * API for managing letter templates and placeholders within an organization. All operations are scoped to the authenticated user\'s organization.  ## Letter Templates  Letter templates define reusable document templates with placeholders that can be filled in when generating letters for clients.  ### Status lifecycle - DRAFT: Initial status, template is being edited - ACTIVE: Template is published and available for use - ARCHIVED: Template is no longer available for new letters  ### Versioning & lineage When an ACTIVE template is updated, a new version is created and the original becomes ARCHIVED. This preserves the exact template used for existing letters.  Every version shares a stable `lineageId` (the chain of edits descended from one original template); the newest version of each lineage is its **head**. The list endpoint returns one row per lineage (heads only) with a computed `versionCount`, while `GET /{id}/versions` returns the full ordered history of a lineage. See ADR-032 for the data model (`lineage_id` / `is_latest`).  ## Authentication All endpoints require Firebase Authentication JWT token in `Authorization: Bearer <token>` header.  ## Error Responses All error responses follow RFC 7807 Problem Details format. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "https://api.scrivio.nl".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
